module.exports = __webpack_public_path__ + "img/industrial-big-data.15536c0f.png";